/** Langues dont l'interface a une traduction. */
export const SUPPORTED_LANGUAGES = ['fr', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

function supported(language: string | null | undefined): SupportedLanguage | null {
  const base = language?.slice(0, 2).toLowerCase()
  return SUPPORTED_LANGUAGES.find(l => l === base) ?? null
}

/**
 * Langue au démarrage, avant que la configuration de l'organisation ne soit
 * chargée : le choix de l'utilisateur, sinon celle de son navigateur, sinon le
 * français (#146).
 */
export function initialLanguage(chosen: string | null, browser: readonly string[]): SupportedLanguage {
  return supported(chosen) ?? browser.map(supported).find(Boolean) ?? 'fr'
}

/**
 * Langue de l'organisation à appliquer une fois sa configuration connue — sauf
 * si l'utilisateur a choisi la sienne, qui l'emporte toujours (#146).
 */
export function organizationLanguage(chosen: string | null, orgDefault: string | null | undefined): SupportedLanguage | null {
  return supported(chosen) ? null : supported(orgDefault)
}
